var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: "详情",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { ref: "ruleForm", staticClass: "popover" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _vm.loginType != 6
                ? _c("el-table-column", {
                    attrs: { prop: "user_id", label: "用户ID" }
                  })
                : _vm._e(),
              _vm.loginType != 6
                ? _c("el-table-column", {
                    attrs: { prop: "gate_user_id", label: "网关用户ID" }
                  })
                : _vm._e(),
              _vm.loginType == 1
                ? _c("el-table-column", {
                    attrs: { prop: "account", label: "账号" }
                  })
                : _vm._e(),
              _vm.loginType == 2
                ? _c("el-table-column", {
                    attrs: { prop: "email", label: "email" }
                  })
                : _vm._e(),
              _vm.loginType == 3
                ? _c("el-table-column", {
                    attrs: { prop: "phone", label: "电话" }
                  })
                : _vm._e(),
              _vm.loginType == 4
                ? _c("el-table-column", {
                    attrs: { prop: "o_type_name", label: "登录类型名称" }
                  })
                : _vm._e(),
              _vm.loginType == 4
                ? _c("el-table-column", {
                    attrs: { prop: "phone", label: "登录类型" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              row.login_type_icon
                                ? [
                                    _c("el-image", {
                                      staticStyle: {
                                        width: "60px",
                                        height: "60px"
                                      },
                                      attrs: {
                                        src: row.login_type_icon,
                                        fit: "cover"
                                      }
                                    })
                                  ]
                                : [_vm._v(" " + _vm._s(row.o_type) + " ")]
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4180883689
                    )
                  })
                : _vm._e(),
              _vm.loginType == 4
                ? _c("el-table-column", {
                    attrs: { prop: "open_id", label: "第三方ID" }
                  })
                : _vm._e(),
              _vm.loginType == 5
                ? _c("el-table-column", {
                    attrs: { prop: "device_id", label: "设备ID" }
                  })
                : _vm._e(),
              _vm.loginType != 6
                ? _c("el-table-column", {
                    attrs: { prop: "create_time", label: "创建时间" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$times.timestampToTime(row.create_time)
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2471839676
                    )
                  })
                : _vm._e(),
              _vm.loginType == 6
                ? _c("el-table-column", {
                    attrs: { prop: "user_id", label: "用户ID" }
                  })
                : _vm._e(),
              _vm.loginType == 6
                ? _c("el-table-column", {
                    attrs: { prop: "name", label: "姓名" }
                  })
                : _vm._e(),
              _vm.loginType == 6
                ? _c("el-table-column", {
                    attrs: { prop: "idcard", label: "身份信息" }
                  })
                : _vm._e(),
              _vm.loginType == 6
                ? _c("el-table-column", {
                    attrs: { prop: "bind_at", label: "绑定时间" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$times.timestampToTime(row.bind_at)
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2190485945
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }